export default (state = null) => state;



// WEBPACK FOOTER //
// ./template/state/modules/version/index.js